import React from 'react';

interface InformSpanProps {
  children: React.ReactNode;
  className?: string;
}

export const InformSpan = ({ children, className = '' }: InformSpanProps) => (
  <div
    className={`text-gray-900 text-center font-body text-[16px] font-regular mx-auto mb-[22px] ${className}`}
  >
    {children}
  </div>
);
